import { createRoute, Outlet } from '@tanstack/react-router';

import DashboardLayout from '@/components/layout/dashboard-layout';

import { protectedRoute } from '../protected/protected-route';

export const dashboardLayoutComponent = createRoute({
  getParentRoute: () => protectedRoute,
  id: 'dashboard',
  component: () => (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
});
